import { render, staticRenderFns } from "./ManualInvoice.vue?vue&type=template&id=513aa3ce&scoped=true"
import script from "./ManualInvoice.vue?vue&type=script&lang=js"
export * from "./ManualInvoice.vue?vue&type=script&lang=js"
import style0 from "./ManualInvoice.vue?vue&type=style&index=0&id=513aa3ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513aa3ce",
  null
  
)

export default component.exports